import React, { useEffect, useState, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ImSearch } from "react-icons/im";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import axiosPrivate from '../../services/axios/axiosPrivate';
import api from '../../services/api';
import { openModal } from '../../redux/slice/managePasswordSlice';
import { getSingleUploadedFile } from "../../redux/slice/filesUploadSlice";
import defaultProfilePic2 from "assets/img/default-profile-pic.png";

export default function Header({ onMenuClick }) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const dropdownRef = useRef(null);
  const userId = useSelector((state) => state?.persistedReducer?.forms?.savedPermissions?.userId ?? '')
  const { isPolicyAccepted, isJoiningFormCompleted } = useSelector((state) => state?.persistedReducer?.forms?.savedPermissions) || {}
  const [dropdownVisible, setDropdownVisible] = useState(false); // State for dropdown visibility
  const [loggedInName, setLoggedInName] = useState(null);
  const [prevPath, setPrevPath] = useState(location.pathname);
  const [userProfileURL, setUserProfileURL] = useState(null)

  // Reset dropdown directly
  if (location.pathname !== prevPath) {
    setPrevPath(location.pathname);
    setDropdownVisible(false);
  }
  const currentRole = localStorage.getItem("role")
  const isSuperAdmin = currentRole === "SUPER_ADMIN"
  const requirementsMet = (isPolicyAccepted && isJoiningFormCompleted) || isSuperAdmin;
  useEffect(() => {
    const getUserName = localStorage.getItem('name');
    if (getUserName) {
      const capitalizedUserName = getUserName.charAt(0).toUpperCase() + getUserName.slice(1);
      setTimeout(() => {
        setLoggedInName(capitalizedUserName);
      }, 0);
    }
  }, []);
  useEffect(() => {
    const fetchProfileImage = async () => {
      try {
        const response = await dispatch(
          getSingleUploadedFile({
            type: 'passportphoto',
            id: userId,
          })
        ).unwrap();
        if (response && response.fileUrl) {
          setUserProfileURL(response.fileUrl);
        } else {
          setUserProfileURL(null);
        }
      } catch (err) {
        console.error("Image fetch failed", err);
        setUserProfileURL(null);
      }
    };

    if (userId) {
      fetchProfileImage();
    }

    return () => {
      if (userProfileURL) {
        URL.revokeObjectURL(userProfileURL);
      }
    };
  }, [userId, dispatch]);

  // handle closing of dropdown on outside click
  useEffect(() => {
    if (!dropdownVisible) return;

    const handleClickOutside = (e) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
        setDropdownVisible(false);
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    }
  }, [dropdownVisible]);

  // Toggle the dropdown visibility
  const toggleDropdown = () => {
    setDropdownVisible(v => !v);
  };

  // handle faq section 
  const handleProfile = () => {
    navigate('/admin/profile')
  }

  // handle faq section 
  const handleFaq = () => {
    navigate('/admin/faq')
  }
  const handleLogout = async () => {
    const token = localStorage.getItem('token');
    const lastPath = location.pathname;
    if (!token) {
      navigate('/');
      return;
    }
    try {
      const result = await axiosPrivate.post(api.logout, {
        headers: {
          'custom-auth-type': 'token'
        }
      });
      if (result?.data?.success === true) {
        navigate('/');
        localStorage.clear();
        sessionStorage.clear();
        localStorage.removeItem("elapsedTime");
        localStorage.removeItem("persist:root");
        globalThis.location.reload();
        sessionStorage.setItem("last Path", lastPath);
      } else {
        toast.error(`${result?.data?.reason}`, {
          className: "toast-error-custom",
        });
      }
    } catch (err) {
      toast.error(err?.message || "server error", { className: "toast-error-custom" });
    }
  }

  const handleImageError = (e) => {
    e.target.src = defaultProfilePic2;
  };
  return (
    <div className='container-fluid header-base px-2 px-md-3'>
      <div className='header-logo d-flex align-items-center w-100'>
        <div className="header-logo-image flex-shrink-0">
          <img src={require("assets/img/Logo.png")} alt="..." />
        </div>
        {/* search bar */}
        {/*<form className="navbar-searchForm d-flex align-items-center position-relative">
          <input className="form-control search" type="search" placeholder="Search" aria-label="Search" />
          <i> <ImSearch className='searchIcon' /></i>
        </form>
        */}
        {/* notification-icons */}
        <div className='d-flex align-items-center ms-auto flex-shrink-0' style={{ marginRight: '10px' }}>
          {/* bell-icon */}
          {/*<div className="dropdown d-flex">
            <button className="btn-interactive nav-link icon d-flex btn btn-default btn-icon m shadow-none" data-toggle="dropdown" aria-expanded="false">
             
              <i className="fa fa-bell" style={{ fontSize: '16px', color: 'white' }}></i>
              <span className="badge badge-primary nav-unread"></span></button>
            <div className="dropdown-menu dropdown-menu-right dropdown-menu-arrowp-0 " ata-x-placement="bottom-end"
              style={{ position: 'absolute', top: '40px', right: '0' }}>
              <ul className="list-unstyled feeds_widget mb-0"> <li><div className="feeds-left"><i className="fa fa-check"></i></div>
                <div className="feeds-body"><h4 className="title text-danger small mb-0">Issue Fixed<small className="float-right text-muted">11:05</small></h4><small>WE have fix all Design bug with Responsive</small>
                </div>
              </li>
                <li><div className="feeds-left">
                  <i className="fa fa-user"></i>
                </div><div className="feeds-body"><h4 className="title">New User <small className="float-right text-muted">10:45</small></h4><small>I feel great! Thanks team</small></div></li>
                <li><div className="feeds-left"><i className="fa fa-thumbs-o-up"></i></div><div className="feeds-body"><h4 className="title">7 New Feedback <small className="float-right text-muted">Today</small></h4><small>It will give a smart finishing to your site</small></div></li>
                <li><div className="feeds-left"><i className="fa fa-question-circle"></i></div><div className="feeds-body"><h4 className="title text-warning">Server Warning <small className="float-right text-muted">10:50</small></h4><small>Your connection is not private</small></div></li><li><div className="feeds-left"><i className="fa fa-shopping-cart"></i></div><div className="feeds-body"><h4 className="title">7 New Orders <small className="float-right text-muted">11:35</small></h4><small>You received a new oder from Tina.</small></div></li>
              </ul>
              <div className="dropdown-divider"></div><a href="fake_url" className="dropdown-item text-center text-muted-dark readall">Mark all as read</a></div>
          </div>
          */}
          <div className="dropdown d-flex align-items-center ms-2" ref={dropdownRef} style={{ position: 'relative' }}>
            <button href="/#" className="nav-link icon d-flex btn btn-default btn-icon dropdown-toggle border-0 shadow-none p-0 align-items-center"
              type="button"
              onClick={toggleDropdown}>
              {/* profile icon */}
              <img
                src={userProfileURL || defaultProfilePic2}
                alt="Profile"
                className="profile-img"
                onError={handleImageError}
                style={{ width: '35px', height: '35px', borderRadius: '50%', objectFit: 'cover' }} />
              <span className="d-none d-sm-flex align-items-center">
                <h5 style={{ margin: 0, marginLeft: '9px', color: 'white' }}>{loggedInName || "Guest"}</h5>
              </span>
            </button>
            <ul className="custom-dropdown-menu"
              style={{
                position: 'absolute',
                top: 'calc(100% + 10px)',
                right: '0',
                zIndex: 9999,
                backgroundColor: '#fff',
                boxShadow: '0px 4px 6px rgba(0, 0, 0, 0.1)',
                padding: '10px',
                borderRadius: '5px',
                visibility: dropdownVisible ? 'visible' : 'hidden',
                opacity: dropdownVisible ? 1 : 0,
                transition: 'opacity 0.2s ease-in-out, visibility 0.2s ease-in-out',
                listStyleType: 'none',
                minWidth: '180px',
                margin: 0
              }}>
              <li><button disabled={!requirementsMet} style={{
                cursor: requirementsMet ? "pointer" : "not-allowed",
                opacity: requirementsMet ? 1 : 0.5
              }} className="btn-interactive dropdown-item cursor-pointer" onClick={() => handleProfile()}
              >Profile</button></li>
              <li><button className="btn-interactive dropdown-item cursor-pointer" onClick={() => dispatch(openModal({ isForNewUser: false }))}
              >Change Password</button></li>
              <li><button disabled={!requirementsMet} style={{
                cursor: requirementsMet ? "pointer" : "not-allowed",
                opacity: requirementsMet ? 1 : 0.5
              }}  className="btn-interactive dropdown-item cursor-pointer" onClick={() => handleFaq()}
              >FAQ</button></li>
              <li><button className="btn-interactive dropdown-item cursor-pointer" onClick={() => handleLogout()}
              >Logout</button></li>
            </ul>

          </div>
          {/* Hamburger icon for mobile */}
          <div className="menu-icon" onClick={onMenuClick}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>

      </div>
    </div>
  );
};

